/**
 * @file Principal componente para construir os tabuleiros aleatórios.
 * @author William Luis Alves Ferreira (git:illiamw)
 * @version 2.0.0
 */
import React from 'react';
import Data from '../assets/data.json';


/**
 * A module that shouts hello!
 * @module Construtor
 */

/** Construtor da classe Construtor de tabuleiro. <br>
 * Nesta classe todos os métodos são utilizados para gerenciar a formação dos tabuleiros */
export default class Construtor extends React.Component {
    /**
     * @constructs Construtor
     * @description Acessa as pré-configurações geradas pela classe [Controle do nível]{@link module:ControlLevel}
     * @param props Elemento pré-definido pela framework React.js com os componentes pai [Módulo raiz]{@link module:Board}
     * @returns Indiretamente as referências geradas seram utilizadas pelo [Controle do Jogo]{@link module:ControlGame}
     */
    constructor(props) {
        
        super(props);
        //porpriedades do tabuleiro
        this.colunas = props.level.getLargura();
        this.quantPalavras = props.level.getQuantidadePalavras();
        this.linhas = props.level.getAltura();
        //conteudo, gabarito e controle do game
        this.tentativas = this.vetorPosibilidades();
        this.gabarito = Array(this.colunas * this.linhas).fill(0);
        this.palavras = { posicoes: Array(), palavras: Array(), ref:Array() }
        this.indexPalavra = 0;
        this.complemento = { dicas: Array(), ajuda: Array() }
        this.count = 0;
        this.dataNivel = []
        this.separaNiveis(props.level.conjuto);
        //console.log(this.colunas,this.linhas)
        //console.log(Data);
        console.log(props.level)
        
    }

    /**
      * @description Testa e posiciona as palavras no tabuleiro
      * @param {Number} rot Indica a rotação, ou seja, orientação das palavras.<br>
      * Sendo elas 0, 1, 2 e 3, respectivamente, horizontal, vertical, diagonal (cima para baixo) e diagonal (baixo para cima).
      * @param {Array} possibilidade Indica possibilidade gerado e mantido em vetor por @module vetorPosibilidades, percorrido pelo método altamente acoplado @method geradorGabarito.
      * @param {String} palavra Indica a palavras coletados do import @module Data e percorrida pelo método 
      * altamente acoplada @method geradorGabarito
      * @returns {boolean} Indicando o sucesso ou fracasso, respectivamente, não posicionou ou posicinou 
      * no posicionamento.
      */
    testOcupa(rot, possibilidade, palavra) {
        var finalposicao;
        var inicialposicao = possibilidade;
        var referencia = Array();
        switch (rot) {
            case 0:
                //horizontal
                finalposicao = palavra.length + possibilidade;

                if (finalposicao > this.colunas * this.linhas) return true;


                for (let index = inicialposicao; index < finalposicao; index++) if (this.gabarito[index] !== 0 && this.gabarito[index] !== palavra[index - possibilidade]) return true;


                for (let index = inicialposicao, inpalavras = 0; index < finalposicao; index++ , inpalavras++) {
                    this.gabarito[index] = palavra[inpalavras];
                    referencia.push(index);
                }
                
                this.palavras.ref.push(this.count);
                this.count += 1;
                this.palavras.posicoes.push(referencia);
                this.palavras.palavras.push(palavra);                
                this.complemento.dicas.push(this.dataNivel[this.indexPalavra]["informacao"]);
                this.complemento.ajuda.push(this.dataNivel[this.indexPalavra]["Help"]);

                return false;


                
            case 1:
                //vertical
                finalposicao = (palavra.length * this.colunas) + possibilidade;

                if (finalposicao > this.colunas * this.linhas) return true;
                for (let index = inicialposicao, inpalavras = 0; index < finalposicao; index += this.colunas, inpalavras++) {
                    if (this.gabarito[index] !== 0 && this.gabarito[index] !== palavra[inpalavras]) return true;
                }

                for (let index = inicialposicao, inpalavras = 0; index < finalposicao; index += this.colunas, inpalavras++) {
                    this.gabarito[index] = palavra[inpalavras];
                    referencia.push(index);
                }

                
                this.palavras.ref.push(this.count);
                this.count += 1;
                this.palavras.posicoes.push(referencia);
                this.palavras.palavras.push(palavra);
                this.complemento.dicas.push(this.dataNivel[this.indexPalavra]["informacao"]);
                this.complemento.ajuda.push(this.dataNivel[this.indexPalavra]["Help"]);
                return false;

                
            case 2:
                //diagonal
                //vertical
                finalposicao = palavra.length + possibilidade;
                finalposicao = (palavra.length * this.colunas) + finalposicao;

                if (finalposicao > this.colunas * this.linhas) return true;
                for (let index = inicialposicao, inpalavras = 0; index < finalposicao; index += this.colunas + 1, inpalavras++) {
                    if (this.gabarito[index] !== 0 && this.gabarito[index] !== palavra[inpalavras]) return true;
                }

                for (let index = inicialposicao, inpalavras = 0; index < finalposicao; index += this.colunas + 1, inpalavras++) {
                    this.gabarito[index] = palavra[inpalavras];
                    referencia.push(index);
                }

                
                this.palavras.ref.push(this.count);
                this.count += 1;
                this.palavras.posicoes.push(referencia);
                this.palavras.palavras.push(palavra);
                this.complemento.dicas.push(this.dataNivel[this.indexPalavra]["informacao"]);
                this.complemento.ajuda.push(this.dataNivel[this.indexPalavra]["Help"]);
                //this.tentativas.pop();
                return false;
                
            case 3:
                //diagonal
                //vertical
                finalposicao = palavra.length + possibilidade;
                finalposicao = finalposicao - (palavra.length * this.colunas); 


                if (finalposicao > this.colunas * this.linhas) return true;
                for (let index = inicialposicao, inpalavras = 0; finalposicao < index; index = index - this.colunas + 1, inpalavras++) {
                    if (this.gabarito[index] !== 0 && this.gabarito[index] !== palavra[inpalavras]) return true;
                }
                //console.log("passou");
                for (let index = inicialposicao, inpalavras = 0; finalposicao < index; index = index - this.colunas + 1, inpalavras++) {
                    this.gabarito[index] = palavra[inpalavras];
                    referencia.push(index);
                    //console.log(index);
                }

                
                this.palavras.ref.push(this.count);
                this.count += 1;
                this.palavras.posicoes.push(referencia);
                this.palavras.palavras.push(palavra);
                this.complemento.dicas.push(this.dataNivel[this.indexPalavra]["informacao"]);
                this.complemento.ajuda.push(this.dataNivel[this.indexPalavra]["Help"]);
                //this.tentativas.pop();
                return false;
                
            default:
                console.log("Erro de rotação");

        }

        //Manter o loop
        return true;
    }

    /**
     * @description Pré-teste de posicionamento de palavras considerando os parâmetros até os limites do tabuleiro
     * @param {Number} rot  Indica a rotação, ou seja, orientação das palavras.<br>
     * Sendo elas 0, 1, 2 e 3, respectivamente, horizontal, vertical, diagonal (cima para baixo) e 
     * diagonal (baixo para cima).
     * @param {Array} possibilidade Indica possibilidade gerado e mantido em vetor por @method vetorPosibilidades, 
     * percorrido pelo método altamente acoplado @method geradorGabarito.
     * @param {String} palavra Indica a palavras coletado do import @module Data e percorrida pelo 
     * método altamente acoplada @method geradorGabarito
     * @returns {boolean} Cascata do @returns {boolean} do @method testOcupa.
     */
    setPosicao(palavra, rot, possibilidade) {
        var xespaco;
        var yespaco;
        switch (rot) {
            case 0:
                //horizontal 
                xespaco = this.colunas - possibilidade % this.colunas;
                if (palavra.length <= xespaco) {

                    return this.testOcupa(rot, possibilidade, palavra);

                }
                break;
            case 1:
                //vertical
                yespaco = this.linhas - Math.round(possibilidade / this.colunas);

                if (palavra.length <= yespaco) {

                    return this.testOcupa(rot, possibilidade, palavra);

                }
                break;
            case 2:
                //diagonal-horario
                xespaco = this.colunas - possibilidade % this.colunas;
                yespaco = this.linhas - Math.round(possibilidade / this.colunas);
                if (palavra.length <= xespaco && palavra.length <= yespaco) {

                    return this.testOcupa(rot, possibilidade, palavra);

                }

                break;
            case 3:
                //diagonal-antihorario
                xespaco = this.colunas - possibilidade % this.colunas;
                yespaco = this.linhas - Math.round(possibilidade / this.colunas);
                //console.log(rot);
                //console.log(this.colunas +' - '+possibilidade +' & '+ this.colunas);
                //console.log('xespaco ' + xespaco + ' '+ palavra);
                //console.log(this.linhas +' - '+ possibilidade +' / '+ this.colunas);
                //console.log('yespaco ' + yespaco + ' '+ palavra);
                if (palavra.length <= xespaco && palavra.length <= yespaco) {

                    return this.testOcupa(rot, possibilidade, palavra);

                }

                break;
            default:
                console.log("Erro de rotação");


        }
        //Manter o loop

        return true;

    }

    /**
     * @description Centralizado pelos métodos @method setPosicao e @method testOcupa, 
     * e deve se manter juntas e acopladas
     * @returns {Array} Retorno o gabarito onde cada celula é preenchida com as letras ou nula.
     */
    geradorGabarito(quantPalavras) {
        var palavra;
        var possibilidade = 0;
        var rot = 0;
        var percorrer = 1;
        var naoinserido = true;

        for (let index = 0; index < quantPalavras; index++) {
            do {
                if (naoinserido) palavra = this.selecionarPalavras(rot);
                do {
                    possibilidade = this.tentativas[this.tentativas.length - percorrer];
                    percorrer++;
                    naoinserido = this.setPosicao(palavra, rot, possibilidade);
                } while (naoinserido && percorrer < this.tentativas.length);
                percorrer = 1;
            } while (naoinserido);
            if (rot >= 3) rot = 0; //Controle de rotação, verificar se retiraremos
            else rot++;
            naoinserido = true;

        }
        //console.log(this.palavras)
        return this.gabarito;
    }

    /**
     * @description Método gerador do vertor de possibilidade, ou seja,
     *  representa a possiveis posições das palavras tomando como referencia a primeira letra.
     * @returns {Array} Retorna o vetor de possibilidades.
     */
    vetorPosibilidades() {
        var tam = this.colunas * this.linhas;
        var posicoes = Array(tam);
        for (let i = 0; i < tam; i++) posicoes[i] = i;
        let aux = 0, ind1, ind2;
        for (let i = 0; i < tam; i++) {
            ind1 = Math.floor(Math.random() * tam);
            ind2 = Math.floor(Math.random() * tam);
            aux = posicoes[ind1];
            posicoes[ind1] = posicoes[ind2];
            posicoes[ind2] = aux;
        }
        return posicoes;
    }

    /**
     * @description Método para selecionar uma palavra ao acaso.
     * @returns {String} Retorna uma palavra aleatória.
     */
    selecionarPalavras(rot) {
        var palavra;
        var MAX;
        switch (rot) {
            case 0:
                MAX = this.colunas;
                break;
            case 1:
                MAX = this.linhas;
                break;
            case 2:
                MAX = this.colunas > this.linhas ? this.colunas : this.linhas;
                break;
            case 3:
                MAX = this.colunas > this.linhas ? this.colunas : this.linhas;
                break;
            default:
                console.log("Erro rotação")

        }

        var len = MAX + 1;
        let flagRep = false;

        while (!(len < MAX && !flagRep)) {
            this.indexPalavra = Math.floor(Math.random() * this.dataNivel.length);

            console.log(this.dataNivel[this.indexPalavra])


            palavra = this.dataNivel[this.indexPalavra]["Resposta"];
            len = palavra.length;
            if(this.palavras.palavras.includes(palavra)) flagRep = true;
            else flagRep = false;
        }

        console.log(this.palavras.palavras.includes(palavra))
        console.log(this.props.level.conjuto, this.dataNivel[this.indexPalavra]["nivel"])
        console.log(len,"<",MAX,",",!flagRep)
        console.log("-----------Selecionado:",this.dataNivel[this.indexPalavra]["Resposta"])

        return palavra;
    }

    /**
     * @description Método necessário para preencher o conteúdo das células com letras aleatórias. 
     * @returns {Array} Retorna o vetor com o conteúdo das células preenchidas com letras aleatórias com as palavras selecionadas e posicionadas.
     */
    geradorChar(value) {
        var alfabeto = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
        var conteudo = Array(value);
        for (let index = 0; index < value; index++) {
            conteudo[index] = alfabeto[Math.floor(Math.random() * alfabeto.length)];
            //conteudo[index] = ".";
        }

        for (let index = 0; index < value; index++) {
            if (this.gabarito[index] !== 0) conteudo[index] = this.gabarito[index];
        }
        return conteudo;
    }

    separaNiveis(nivel){
        for(let palavra in Data){
            console.log(Data[palavra]['nivel'])
            if(Data[palavra]['nivel'] === nivel) {
                this.dataNivel.push(Data[palavra])
            }            
        }
    }

}
